<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
    <div class="clients-panel cash-list">
      <div class="clients-panel-container">
        <el-row class="black-inputs">
          <div class="cash-header">
            <div class="nav-toggle" @click="showHideScreenResaList">
              <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
            </div>
          </div>
          <br>
          <el-row class="dateChooser" :gutter="5">
            <el-col class="alignCenter" :md="{ span: 4 }" :sm="{ span: 8 }" :xs="24">
              <el-date-picker class="datePicker" v-model="datesResaStart" type="date" :picker-options="pickerOptions"
                placeholder="Date de début" @change="updateResaDateStart()" format="dd/MM/yyyy">
              </el-date-picker>
            </el-col>
            <el-col class="alignCenter" :md="{ span: 4, offset: 1 }" :sm="{ span: 8 }" :xs="24">
              <el-date-picker class="datePicker" v-model="datesResaEnd" type="date" :picker-options="pickerOptions"
                placeholder="Date de fin" @change="updateResaDateEnd()" format="dd/MM/yyyy">
              </el-date-picker>
            </el-col>
            <el-col :md="{ span: 4, offset: 1 }" :sm="{ span: 8 }" :xs="24">
              <el-select v-model="serviceResa" placeholder="Service">
                <el-option v-for="t in getServices" :key="t" :label="t" :value="t">
                </el-option>
              </el-select>
            </el-col>
            <el-col :md="{ span: 3, offset: 0 }" :xs="24" :sm="{ span: 8 }">
              <el-button type="primary" @click="showResaEntry()">Afficher</el-button>
            </el-col>
            <el-col :md="{ span: 3, offset: 0 }" :xs="24" :sm="{ span: 8 }">
              <el-button :disabled="resasList.length === 0" class="dark" @click="printResas">Imprimer</el-button>
            </el-col>
            <el-col :md="{ span: 3, offset: 1 }" :xs="24" :sm="{ span: 8 }">
              <el-button v-if="datesResaStart !== '' && datesResaEnd !== ''" class="dark"
                @click="reinit()">Réinitialiser</el-button>
              <div v-else style="height:1px; width:100%"> </div>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="black-inputs">
          <el-col id="listResasToPrint" :md="24" class="screen-clients resa-list">
            <div v-for="(resa, index) in resasList" :key="index" class="print-ok">
              <div v-if="index === 0 || resasList[index - 1].dateResa.labelMonth !== resa.dateResa.labelMonth">
                {{ resa.dateResa.labelMonth }} {{ resa.dateResa.year }}
                <div class="seperator"></div>
                <div class="hide" style="width:100%; border-bottom:1px solid black; margin:10px 0"></div>
              </div>
              - {{ resa.dateResa.labelDay }} {{ resa.dateResa.day }} - {{ resa.hour }} <span v-if="resa.room !== ''">-
                {{ getRoomName(resa.room) }} </span>
              - {{ getClientByid(resa.cid).civ }} {{ getClientByid(resa.cid).name }} {{ getClientByid(resa.cid).prenom
              }}
              <a class="phone-link" v-if="getClientByid(resa.cid).tel && getClientByid(resa.cid).tel !== ''"
                :href="'tel:' + formatPhone(getClientByid(resa.cid).tel, getClientByid(resa.cid).telPreFix)">
                - {{ formatPhone(getClientByid(resa.cid).tel, getClientByid(resa.cid).telPreFix) }} -
              </a>
              ( {{ resa.nbCouvert }} ) <span v-if="getAllTablesString(resa) !== ''">- {{ getAllTablesString(resa)
              }}</span>
              <span v-if="resa.allergen"><span class="icon-allergen"></span><span class="hide">- allergène /
                  intolérance</span><span class="allergen-text">({{ resa.allergenMessage }})</span></span>
              <span v-if="resa.commentResa && resa.commentResa !== ''">
                <span style="margin-left:10px"> -> {{ resa.commentResa }}</span>
              </span>
              - <i class="el-icon-view icon-btn" @click="gotoResa(resa)"></i>
              <div class="seperator-light"></div>
              <div class="hide" style="width:100%; border-bottom:1px dashed black; margin:10px 0"></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as resaState from '../../store/types/resa-state';
import { dateToTimeStampHourMinutes, parseTime } from '../../tools/timeTool';

export default {
  name: 'ResaList',
  components: {},
  data() {
    return {
      datesResa: {},
      datesResaStart: '',
      datesResaEnd: '',
      serviceResa: 'Tous les services',
      resasList: [],
      loading: false,
      loadingDelete: false,
      pickerOptions: {
        firstDayOfWeek: 1
      }
    }
  },
  computed: {
    ...mapGetters({
      getAllServicesIdsAndName: 'newServices/getAllServicesIdsAndName',
      getLabelMonth: 'calendar/getLabelMonth',
      getClientByid: 'newClients/getClientByid',
      getAllInfos: 'infos/getAllInfos',
      getResaListDateStart: 'newReservations/getResaListDateStart',
      getResaListDateEnd: 'newReservations/getResaListDateEnd',
      getRoomName: 'newRooms/getRoomName'
    }),
    getServices: function () {
      let tabServices = this.getAllServicesIdsAndName.slice()
      tabServices.unshift('Tous les services')
      return tabServices
    }
  },
  mounted: function () {
    this.datesResaStart = this.getResaListDateStart
    this.datesResaEnd = this.getResaListDateEnd
    if (this.datesResaStart !== '' && this.datesResaEnd !== '') {
      this.showResaEntry()
    }
  },
  methods: {
    ...mapActions({
      showHideScreenResaList: 'displayer/showHideScreenResaList',
      getResasTsToTs: 'newReservations/getResasTsToTs',
      showHidePopupManageServices: 'displayer/showHidePopupManageServices',
      showVisibilityCalendar: 'calendar/showVisibilityCalendar'
    }),
    ...mapMutations({
      setSelectedDay: 'calendar/setSelectedDay',
      setSelectedService: 'newServices/setSelectedService',
      setModLinkTable: 'newRooms/setModLinkTable',
      setSelectedResa: 'newReservations/setSelectedResa',
      setResaListDateStart: 'newReservations/setResaListDateStart',
      setResaListDateEnd: 'newReservations/setResaListDateEnd'
    }),
    strUcFirst: function (a) {
      return ((`${a}`).charAt(0).toUpperCase() + a.substr(1))[0]
    },
    dateRenderer: function (date) {
      return `${this.leadingZero(date.getDate())}/${this.leadingZero(date.getMonth() + 1)}/${date.getFullYear()}`
    },
    leadingZero(value) {
      return (`0${value}`).slice(-2)
    },
    formatPhone: function (phone, phonePreFix) {
      if (phone.length < 3) return null
      if (phonePreFix !== '' && phone[0] !== '+') {
        let p = phone
        if (phone[0] === '0') p = phone.substring(1)
        return phonePreFix + p
      } else if (phone[0] !== '0' && phone[0] !== '+') {
        return `0${phone}`
      }
      return phone
    },
    reinit() {
      this.datesResaStart = ''
      this.datesResaEnd = ''
      this.serviceResa = 'Tous les services'
      this.setResaListDateStart(this.datesResaStart)
      this.setResaListDateEnd(this.datesResaEnd)
      this.showResaEntry()
    },
    gotoResa: function (resa) {
      this.vars.$emit('bubleclose', false)
      this.setSelectedDay(resa.dateResa)
      this.setSelectedService({ ms: resa.ms, subs: resa.subs })
      this.setSelectedResa(resa)
      this.setModLinkTable(true)
      this.showHidePopupManageServices()
      this.showVisibilityCalendar(false)
    },
    updateResaDateStart: function () {
      this.setResaListDateStart(this.datesResaStart)
    },
    updateResaDateEnd: function () {
      this.setResaListDateEnd(this.datesResaEnd)
    },
    showResaEntry: function () {
      if (this.datesResaStart !== '' && this.datesResaEnd !== '') {
        let startDate = this.datesResaStart
        let endDate = this.datesResaEnd
        this.getResasTsToTs({
          startDay: startDate.getDate(),
          startMonth: startDate.getMonth(),
          startYear: startDate.getFullYear(),
          endDay: endDate.getDate(),
          endMonth: endDate.getMonth(),
          endYear: endDate.getFullYear()
        }).then((res) => {
          if (this.serviceResa !== 'Tous les services') {
            this.resasList = res.filter(el => {
              return el.ms === this.serviceResa
            })
          } else {
            this.resasList = res
          }

          // remove resa cancelled
          let realResaList = []
          this.resasList.forEach(resa => {
            if (resa.state !== resaState.CANCELLED) realResaList.push(resa)
          })

          // sort by date
          realResaList.sort((a, b) => {
            let dateA = dateToTimeStampHourMinutes(a.dateResa.day, a.dateResa.month - 1, a.dateResa.year, parseTime(a.hour).hours, parseTime(a.hour).minutes)
            let dateB = dateToTimeStampHourMinutes(b.dateResa.day, b.dateResa.month - 1, b.dateResa.year, parseTime(b.hour).hours, parseTime(b.hour).minutes)
            return dateA - dateB
          })

          this.resasList = realResaList
        })
      } else {
        this.resasList = []
      }
    },
    getAllTablesString: function (resa) {
      let tmp = ''
      if (!resa || !resa.tids || !resa.tids.length === 0) return ''
      resa.tids.forEach((val, index) => {
        tmp += val.toString()
        if (index < resa.tids.length - 1) tmp += ' / '
      })
      return tmp
    },
    printResas: function (e) {
      e.preventDefault()
      e.stopPropagation()
      var mywindow = window.open('', 'PRINT', 'height=600,width=800')

      mywindow.document.write(`<html><head><title>${document.title}</title>`)
      mywindow.document.write('<style type="text/css">body{font-family:Arial}.el-col{display:inline-block}.resaline-state{display:none;}.resaline-row:before{content:" - ";display:inline-block; margin-right:10px;}.resaline-tags{display:none;}</style>')
      mywindow.document.write('</head><body >')
      // set logo image
      var img = mywindow.document.createElement('img')
      img.setAttribute('src', 'https://staging.resa.ninja/icons/apple-touch-icon-120x120.png')
      img.style.display = 'block'
      img.style.position = 'absolute'
      img.style.left = '0'
      img.width = '80'
      img.height = '80'
      mywindow.document.body.appendChild(img)

      mywindow.document.write(`<div style="text-align:center; font-size:23px;margin-bottom:15px;"><strong>${this.getAllInfos.restoName}</strong><br><strong>Réservations du<br>${this.dateRenderer(this.datesResaStart)} au ${this.dateRenderer(this.datesResaEnd)}</strong></div>`)
      // retrive all resas to print with classname print-ok
      let resasToPrint = document.getElementById('listResasToPrint').getElementsByClassName('print-ok')
      let innerHtml = ''
      for (let i = 0; i < resasToPrint.length; i++) {
        innerHtml += resasToPrint[i].innerHTML
      }
      // print
      mywindow.document.write(innerHtml)
      mywindow.document.write('</body></html>')

      mywindow.document.close() // necessary for IE >= 10
      mywindow.focus() // necessary for IE >= 10*/

      // hack for ios don't update dom imediatly
      /* this.vars.$nextTick(() => {
        mywindow.print()
        // mywindow.close()
      }) */
      mywindow.onafterprint = () => {
        mywindow.document.body.removeChild(mywindow.document.body)
        mywindow.close()
      }
      mywindow.onload = () => {
        mywindow.print()
        setTimeout(function () { window.close() }, 100)
      }
      mywindow.onclose = () => {
        mywindow.close()
      }

      return true
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/mixins";
@use "../../styles/vars";

.seperator {
  border-top: 1px solid vars.$color_white;
  margin: 10px 0;
}

.phone-link {
  color: vars.$color_blue_azure;
  text-decoration: none;
}

.seperator-light {
  border-top: 1px solid vars.$dark__line_color-light;
  margin: 10px 0;
}

.icon-allergen {
  background-image: url("../../assets/svg/asset-allergen.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px 16px;
  width: 16px;
  height: 16px;
  display: inline-block;
  margin: 0 10px;
}

.allergen-text {
  color: #f13030;
}

.resa-list {
  padding: 0 30px;
  font-size: 14px;

  @include mixins.mobile-portrait {
    font-size: 14px;
  }

  @include mixins.mobile-landscape {
    font-size: 14px;
  }
}

.hide {
  display: none;
}

.icon-btn {
  cursor: pointer;
}

.alignCenter {
  @include mixins.mobile-portrait {
    text-align: center;
  }

  @include mixins.mobile-landscape {
    text-align: center;
  }
}

.cash-list {
  button {
    height: 48px;
  }

  .el-col {
    @include mixins.mobile-landscape {
      margin-bottom: 10px;
    }

    @include mixins.mobile-portrait {
      margin-bottom: 10px;
    }
  }

  .el-range {
    &-editor {
      @include mixins.mobile-portrait {
        height: 100% !important;
        width: 100% !important;
        display: block;
        text-align: center;
      }
    }

    &__icon {
      @include mixins.mobile-portrait {
        display: block;
        width: 100%;
      }
    }

    &-input {
      @include mixins.mobile-portrait {
        display: block;
        height: 35px;
        width: 100%;
      }
    }

    &-separator {
      @include mixins.mobile-portrait {
        display: block;
        width: 90%;
      }
    }

    &__close-icon {
      @include mixins.mobile-portrait {
        top: 0;
        right: 10px;
        height: 35px;
        position: absolute;
      }
    }
  }
}

.inputEuro {
  text-align: center;

  &:after {
    content: '€';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 16px;
  }
}

.inputCouv {
  text-align: center;

  &:after {
    content: 'couv.';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 14px;
  }
}

.el-input__inner {
  text-align: center;
  width: 100%;
}

.mobile-show {
  display: none;

  @include mixins.mobile-landscape {
    display: block;
  }
}

.mobile-hide {
  display: block;
  padding: 0 10px;

  @include mixins.mobile-landscape {
    display: none;
  }
}
</style>
